import { SYNC_STATUS_OPTIONS } from "../constants";

export const TIME_ENTRY_SYNC_FIELDS = {
sync_status: {
    type: "select",
    label: "Sync Status",
    options: SYNC_STATUS_OPTIONS.map((option) => ({
      label: option.label,
      value: option.value,
    })),
    validation: {
      required: false,
    },
    // Table properties
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    filterType: "exact",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Settings",
    // Internal QuickBooks sync detail — staff only.
    allowedRoles: ["wtc_employee", "wtc_admin"] as string[],
    mobileDetailSectionId: "sync",
  },
quickbooks_id: {
    type: "text",
    label: "QuickBooks ID",
    placeholder: "QuickBooks reference ID",
    excludeFromApi: true, // Don't include in API submission for new entries
    // Table properties
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false, // Read-only
    filterType: "contains",
    width: 150,
    minWidth: 120,
    maxWidth: 200,
    icon: "Settings",
    // Internal QuickBooks sync detail — staff only.
    allowedRoles: ["wtc_employee", "wtc_admin"] as string[],
    mobileDetailSectionId: "sync",
  },
approved_at: {
    type: "datetime",
    label: "Approved At",
    excludeFromApi: true, // Don't include in API submission for new entries
    sortable: true,
    resizable: true,
    hideable: true,
    editable: false, // Auto-generated timestamp when approved
    width: 160,
    minWidth: 120,
    maxWidth: 220,
    icon: "CheckCircle",
    // Internal approval timestamp — staff only.
    allowedRoles: ["wtc_employee", "wtc_admin"] as string[],
    mobileDetailSectionId: "approval",
  },
synced_at: {
    type: "datetime",
    label: "Synced At",
    excludeFromApi: true, // Don't include in API submission for new entries
    sortable: true,
    resizable: true,
    hideable: true,
    editable: false, // Auto-generated timestamp when synced
    width: 160,
    minWidth: 120,
    maxWidth: 220,
    icon: "Settings",
    // Internal QuickBooks sync detail — staff only.
    allowedRoles: ["wtc_employee", "wtc_admin"] as string[],
    mobileDetailSectionId: "sync",
  }
} as const;
